import { defineMessages } from 'react-intl';
import { twelveHourUserSetting } from '../../constants/timezone-format';

const messages = defineMessages({
  createLabel: {
    description: 'userSettings.v3.configureShipmentWidget.actionButton.createLabel',
    defaultMessage: 'Create Label',
    id: 'R8+1BC',
  },
  createAndPrintLabel: {
    description: 'userSettings.v3.configureShipmentWidget.actionButton.createAndPrintLabel',
    defaultMessage: 'Create + Print Label',
    id: 'p7t0cr',
  },
  upc: {
    description: 'userSettings.v3.scanToVerify.verifyItemsBy.upc',
    defaultMessage: 'UPC',
    id: '0gXscL',
  },
  itemSku: {
    description: 'userSettings.v3.scanToVerify.verifyItemsBy.itemSku',
    defaultMessage: 'Item SKU',
    id: 'l7hUxR',
  },
  fulfillmentSku: {
    description: 'userSettings.v3.scanToVerify.verifyItemsBy.fulfillmentSku',
    defaultMessage: 'Fulfillment SKU',
    id: '5u9JNZ',
  },
  makeUsersClickMarkAsVerified: {
    description: 'userSettings.v3.scanToVerify.requireManualConfirmation.click',
    defaultMessage: "Make users click 'Mark as Verified' to confirm all items are verified before moving to the next step",
    id: 'q3XPW+',
  },
  automaticallyPrintAfterVerified: {
    description: 'userSettings.v3.scanToVerify.requireManualConfirmation.automatic',
    defaultMessage: 'Automatically take users to the next step once all order items are verified',
    id: '58XSAq',
  },
  twelveHour: {
    description: 'userSettings.v3.timeFormat.24',
    defaultMessage: '12 hour am/pm',
    id: 'IMUSz6',
  },
  twentyFourHour: {
    description: 'userSettings.v3.timeFormat.24',
    defaultMessage: '24 hour',
    id: 'T9eO/q',
  },
  dayMonthYearLong: {
    description: 'settings.displayoptions.dayMonthYearLong',
    defaultMessage: 'dd/mm/yyyy',
    id: 'V939qE',
  },
  dayMonthYearShort: {
    description: 'settings.displayoptions.dayMonthYearShort',
    defaultMessage: 'dd/mm/yy',
    id: 'nK8a1N',
  },
  monthDayYearLong: {
    description: 'settings.displayoptions.monthDayYearLong',
    defaultMessage: 'mm/dd/yyyy',
    id: '3MfaGm',
  },
  monthDayYearShort: {
    description: 'settings.displayoptions.monthDayYearShort',
    defaultMessage: 'mm/dd/yy',
    id: 'frYShY',
  },
  quickshipAlwaysShowCostSummary: {
    description: 'UserSettings Quickship ShowCostSummary alwaysShowCostSummary',
    defaultMessage: 'Always show',
    id: 's8fkDu',
  },
  quickshipShowCostSummaryIfNeeded: {
    description: 'UserSettings Quickship ShowCostSummary showCostSummaryIfNeeded',
    defaultMessage: 'Show only when funds are needed',
    id: '/YOCEa',
  },
  loginToInsightsOverview: {
    description: 'userSetting to direct the user to the insights overview page on login',
    defaultMessage: 'Insights - Overview',
    id: 'Rp2yKO',
  },
  loginToInsightsOperations: {
    description: 'userSetting to direct the user to the insights operations page on login',
    defaultMessage: 'Insights - Operations',
    id: 'q59Qjf',
  },
  loginToInsightsSalesTrends: {
    description: 'userSetting to direct the user to the insights sales trends page on login',
    defaultMessage: 'Insights - Sales Trends',
    id: 'cGuroi',
  },
  loginToInsightsCustomerOverview: {
    description: 'userSetting to direct the user to the insights customer overview page on login',
    defaultMessage: 'Insights - Customer Overview',
    id: 'DUV6gU',
  },
  loginToInsightsProductHighlights: {
    description: 'userSetting to direct the user to the insights product highlights page on login',
    defaultMessage: 'Insights - Product Highlights',
    id: 'V2Va4g',
  },
  loginToOrders: {
    description: 'userSetting to direct the user to the orders page on login',
    defaultMessage: 'Orders',
    id: 'wtNmIT',
  },
  loginToShipments: {
    description: 'userSetting to direct the user to the shipments page on login',
    defaultMessage: 'Shipments',
    id: 'jg2iAk',
  },
  loginToProducts: {
    description: 'userSetting to direct the user to the products page on login',
    defaultMessage: 'Products',
    id: '/DNhvo',
  },
  loginToCustomers: {
    description: 'userSetting to direct the user to the customers page on login',
    defaultMessage: 'Customers',
    id: 'SFE3tc',
  },
});

export const V2_INSIGHTS_OVERVIEW_PATH = '#/dashboard';
export const V2_INSIGHTS_OPERATIONS_PATH = '#/dashboard/operations';
export const V2_INSIGHTS_SALES_PATH = '#/dashboard/sales';
export const V2_INSIGHTS_CUSTOMERS_PATH = '#/dashboard/customers';
export const V2_INSIGHTS_PRODUCTS_PATH = '#/dashboard/products';
export const V2_ORDERS_PATH = '#/orders';
export const V2_SHIPMENTS_PATH = '#shipments';
export const V2_PRODUCTS_PATH = '#/products';
export const V2_CUSTOMERS_PATH = '#/customers';

const userSettingsValues = {
  createLabel: {
    settingValue: 'createLabel',
  },
  createAndPrintLabel: {
    settingValue: 'createAndPrintLabel',
  },
  loginToInsightsOverview: {
    settingValue: V2_INSIGHTS_OVERVIEW_PATH,
  },
  loginToInsightsOperations: {
    settingValue: V2_INSIGHTS_OPERATIONS_PATH,
  },
  loginToInsightsSalesTrends: {
    settingValue: V2_INSIGHTS_SALES_PATH,
  },
  loginToInsightsCustomerOverview: {
    settingValue: V2_INSIGHTS_CUSTOMERS_PATH,
  },
  loginToInsightsProductHighlights: {
    settingValue: V2_INSIGHTS_PRODUCTS_PATH,
  },
  loginToOrders: {
    settingValue: V2_ORDERS_PATH,
  },
  loginToShipments: {
    settingValue: V2_SHIPMENTS_PATH,
  },
  loginToProducts: {
    settingValue: V2_PRODUCTS_PATH,
  },
  loginToCustomers: {
    settingValue: V2_CUSTOMERS_PATH,
  },
  upc: {
    settingValue: 'UPC',
  },
  itemSku: {
    settingValue: 'Item SKU',
  },
  fulfillmentSku: {
    settingValue: 'Fulfillment SKU',
  },
  makeUsersClickMarkAsVerified: {
    settingValue: true,
  },
  automaticallyPrintAfterVerified: {
    settingValue: false,
  },
  twelveHour: {
    settingValue: twelveHourUserSetting,
  },
  twentyFourHour: {
    settingValue: 'HH:mm',
  },
  dayMonthYearLong: {
    settingValue: 'DD/MM/YYYY',
  },
  dayMonthYearShort: {
    settingValue: 'DD/MM/YY',
  },
  monthDayYearLong: {
    settingValue: 'MM/DD/YYYY',
  },
  monthDayYearShort: {
    settingValue: 'MM/DD/YY',
  },
  shouldReceiveWeeklyDigest: {
    settingValue: true,
  },
  dontReceiveWeeklyDigest: {
    settingValue: false,
  },
  quickshipAlwaysShowCostSummary: {
    settingValue: 'alwaysShowCostSummary',
  },
  quickshipShowCostSummaryIfNeeded: {
    settingValue: 'showCostSummaryIfNeeded',
  },
  quickshipNeverShowCostSummary: {
    settingValue: 'neverShowCostSummary',
  },
  prepayDutyAlert: {
    settingValue: {
      createdPrepayDutyOn: '',
      dismissedOn: '',
    },
  },
};

Object.keys(userSettingsValues).forEach((setting) => {
  userSettingsValues[setting].messageDescriptor = messages[setting];
});

export default userSettingsValues;
